import { Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { resolve } from 'path-browserify';
import React from 'react'
import { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';
import readXlsFile from 'read-excel-file';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

class Asiduidad extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            consulta: {
                anio: '',
            },
            datosMov:[],
            consultaAsiduidad: false,
        }
        this.manejarCambioDatos = this.manejarCambioDatos.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
    }
    render(){
        return (
            <>
                <Container>
                    <h3>ASIDUIDAD</h3>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <Box sx={{ flexGrow: 1}} >
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={3}>

                            </Grid>
                            <Grid item xs={2}>
                                <Item>Año</Item>
                            </Grid>
                            <Grid item xs={2}>
                                <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consulta.anio} onChange={this.manejarCambioDatos}/>
                            </Grid>
                            <Grid item xs={2}>
                                <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioConsulta}>Consultar</button>
                            </Grid>
                        </Grid>
                    </Box>
                    <br/>
                    {this.state.consultaAsiduidad
                    ?
                        <Container>
                            <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                            </ReactHtmlTableToExcel>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Numero</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Enfermedad</StyledTableCell>
                                            <StyledTableCell>Estudio/Examen</StyledTableCell>
                                            <StyledTableCell>Extraordinaria S/Sueldo</StyledTableCell>
                                            <StyledTableCell>Falta con Aviso</StyledTableCell>
                                            <StyledTableCell>Falta Sin Aviso</StyledTableCell>
                                            <StyledTableCell>Suspensión</StyledTableCell>
                                            <StyledTableCell>Pase en Comisión</StyledTableCell>
                                            <StyledTableCell>Estudio/Parcial</StyledTableCell>
                                            <StyledTableCell>Subsidio Transitorio</StyledTableCell>
                                            <StyledTableCell>Desde</StyledTableCell>
                                            <StyledTableCell>Hasta</StyledTableCell>
                                            <StyledTableCell>Días</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosMov.map((datoPro, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell>{datoPro.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{datoPro.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{datoPro.enfermedad}</StyledTableCell>
                                                <StyledTableCell>{datoPro.estudioExamen}</StyledTableCell>
                                                <StyledTableCell>{datoPro.extraSSueldo}</StyledTableCell>
                                                <StyledTableCell>{datoPro.aviso}</StyledTableCell>
                                                <StyledTableCell>{datoPro.sinAviso}</StyledTableCell>
                                                <StyledTableCell>{datoPro.suspension}</StyledTableCell>
                                                <StyledTableCell>{datoPro.paseComision}</StyledTableCell>
                                                <StyledTableCell>{datoPro.estudioParcial}</StyledTableCell>
                                                <StyledTableCell>{datoPro.subsTransBPS}</StyledTableCell>
                                                <StyledTableCell>{datoPro.desde}</StyledTableCell>
                                                <StyledTableCell>{datoPro.hasta}</StyledTableCell>
                                                <StyledTableCell>{datoPro.dias}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                        </Container>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    manejarCambioDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.consulta;
            numFunActualizado[clave] = valor;
            return{
                consulta: numFunActualizado,
            };
        });
    }

    async manejarEnvioConsulta(e){
        e.preventDefault();
        if(this.state.consulta.anio === ''){
            this.setState({
                errores: ' Debe ingresar el año a consultar',
            })
        }else{
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.consulta]);
            const control = await fetch(`${Constantes.RUTA_API}/obtener_asiduidad.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
                loading: false,
            });

            if(res[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    datosMov: res[1],
                    consultaAsiduidad: true,
                })
            }
        }
    }
}

export default Asiduidad